export default {
    // nome app
    "SalesPaddy":"SalesPaddy",
    "Submit": "Invia",
    "Note": "Note",
    "NoFeedbackMsg": "Al momento non ci sono valutazioni da effettuare.",
    "FillInstruction": {
        "p_1": "Ti chiediamo di dedicare qualche minuto per valutare i docenti delle materie che hai seguito questa settimana. Il tuo feedback è fondamentale per aiutarci a migliorare la qualità dell’insegnamento.",
        "p_2": "Puoi lasciare un commento facoltativo per ogni valutazione."
    },
    "Err_Unfilled": "Inserisci un valore per ogni elemento",
    "ThankYouMessage": {
        "p_1": "Grazie per aver dedicato del tempo a fornire il tuo feedback.",
        "p_survey": "Le tue risposte sono preziose per migliorare l’esperienza didattica di tutti.",
    },
    "SegnalazioneInstruction": {
        "p_1": "Qui puoi inviare una segnalazione anonima riguardo a un insegnante o a una situazione che hai vissuto.",
        "p_2": "Il tuo contributo ci aiuta a individuare eventuali criticità e a intervenire tempestivamente.",
        "p_3": "Ti assicuriamo che non sarà possibile risalire alla tua identità.",
    }
}